export default class FetchSnippetRevisions {
  constructor(context) {
    this.context = context;
  }

  run(snippetId) {
    this.context.gateways.snippetRevision.request({ snippetId });
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/knowledge_base/fetch_snippet_revisions.js